import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateFormData } from "../../../utils/validation";
import { errorMsg, successMsg } from "../../../utils/customFn";
import useApiRequest from "../../../hook/useApiRequest";
import Joi from "joi";
import { API_ENDPOINTS } from "../../../constants/endPoints";

const useAddPageUtils = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loading, fetchData } = useApiRequest();
  const languageId = localStorage.getItem("language_id") || "1";
  const [formErrors, setFormErrors] = useState({});
 
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    page_id: "",
    language_id: languageId,
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const fetchPageData = async () => {
   
    const response = await fetchData(
      `${API_ENDPOINTS?.get_pages}/${id}?language_id=${formData?.language_id}`,
      navigate
    );

    if (response) {
      setFormData((prev) => ({
        ...prev,
        title: response?.page_descriptions?.title || "",
        description: response?.page_descriptions?.description || "",
        page_id: id,
        status: response?.status,
        languageId: languageId,
      }));
    }
  };

  useEffect(() => {
    fetchPageData();
  }, [id , formData?.language_id]);

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      const validationSchema = Joi.object({
        title: Joi.string()
          .required()
          .label("Title"),
        description: Joi.string()
          .required()
          .label("description"),
      }).options({ abortEarly: false, allowUnknown: true });

      const { status, errors } = await validateFormData(
        formData,
        validationSchema
      );

      setFormErrors(errors);
      if (!status) return;

      const url = id ? `${API_ENDPOINTS.edit_page}/${id}` : "";
      const response = await fetchData(url, navigate, "PATCH", formData);

      if (response) {
        if (id) {
          successMsg("Page has been successfully updated.");
        }
        navigate("/pages");
      }
    } catch (err) {
      errorMsg("An error occurred during submission.");
      console.error("Error during form submission:", err);
    } finally {
    }
  };

  return {
    formData,
    loading,
    fetchData,
    handleFormChange,
    submitForm,
    formErrors,
    setFormData,
    navigate
  };
};

export default useAddPageUtils;
